import faqReducer from './reducer';

export default faqReducer;

export {
  SET_LANGUAGE,
  CHANGE_LANGUAGE_REQUEST,
  CHANGE_LANGUAGE_SUCCESS,
  CHANGE_LANGUAGE_FAILURE,
  setLanguage,
  changeLanguageRequest,
  changeLanguageSuccess,
  changeLanguageFailure
} from './actions';

export { isChangingLanguage, getCurrentLanguage } from './selectors';



// WEBPACK FOOTER //
// ./src/store/language/index.js